export const environment = {
  production: true,
  buildId: '2713675214918542',
  configFile: 'config.json',
};
